import { useReactiveVar } from '@apollo/client'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { TextField } from '@material-ui/core'
import { stripDoubleSpacesTrimStart } from 'bpm/shared/utils/inputUtils'
import clsx from 'clsx'
import React, { FC, useCallback, useMemo } from 'react'
import { MODEL_MAX_LENGTH } from './AddNewProductModal'
import { RadioType } from './AddProductTypes'
import {
    addProductDialogState,
    setProductDialogState,
} from './addProductFormHandler'
import { useAddProductFormStyles } from './formStyles'

const ProductModelNumberInput: FC = () => {
    const classes = useAddProductFormStyles()

    const {
        firmName,
        familyRadio,
        sectionNames,
        sectionNumber,
        sectionTitle,
        categories,
        productType,
        model,
    } = useReactiveVar(addProductDialogState)

    const isModelNumberDisabled = useMemo(
        () =>
            !firmName ||
            (familyRadio === RadioType.Existing
                ? !sectionNames
                : !sectionNumber || !sectionTitle || !categories.length) ||
            !productType,
        [
            firmName,
            sectionNames,
            sectionNumber,
            sectionTitle,
            familyRadio,
            categories,
            productType,
        ]
    )
    const handleChange = useCallback(
        (e) => {
            setProductDialogState({
                model: stripDoubleSpacesTrimStart(e.target.value),
            })
        },
        [setProductDialogState, stripDoubleSpacesTrimStart]
    )

    return (
        <GridItem
            className={clsx(
                classes.rowContainer,
                classes.smallContainer,
                'rowContainer'
            )}
            xs={7}
            data-testid="model"
        >
            <TextField
                className={classes.inputField}
                name="model"
                fullWidth
                disabled={isModelNumberDisabled}
                value={model}
                variant="outlined"
                inputProps={{ maxLength: MODEL_MAX_LENGTH }}
                onChange={handleChange}
                label="Product Model Number"
            />
        </GridItem>
    )
}
export default ProductModelNumberInput
